import {Meta} from '../../types/Meta';
import {formatDate} from '../../dates/dates';

export type CalendarMod = {
  dateMap: {[key: string]: CalendarModDate};
};

export type CalendarModDate = {
  ymd: string;
  name?: string;
  color?: string;
  backgroundColor?: string;
};

export type MetaHolder = {
  meta?: Meta;
};

export function buildCalendarMod(
  metaHolder: MetaHolder,
): CalendarMod | undefined {
  const meta = metaHolder.meta;

  if (!meta) {
    return;
  }

  const dates = buildCalendarModDates(meta['_calmod_dates']);
  const dateMap: {[key: string]: CalendarModDate} = {};

  for (let date of dates) {
    dateMap[date.ymd] = date;
  }

  return {
    dateMap,
  };
}

function buildCalendarModDates(xs: any): CalendarModDate[] {
  const result: CalendarModDate[] = [];

  if (!xs) {
    return result;
  }

  if (Array.isArray(xs)) {
    for (let x of xs) {
      const date = buildDate(x);

      if (date) {
        result.push(date);
      }
    }
  }

  return result;
}

function buildDate(x: any): CalendarModDate | null {
  if (x.date && x.background_color) {
    return {
      ymd: formatDate(new Date(x.date)),
      name: x.name,
      color: x.color,
      backgroundColor: x.background_color,
    };
  }

  return null;
}
